import MobileHomePage from './MobileHomePage';

export default MobileHomePage;
